import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { EvaButtonModule } from '../eva-button/eva-button.module';
import { TagTextModule } from '../tag-text/tag-text.module';
import { FormModuleComponent } from './form.component';
import { InputsWrapperComponent } from './inputs-wrapper.component';

import {
  AutocompleteInputComponent,
  CommonInputComponent,
  RadiosInputComponent,
  SelectorInputComponent,
  TextareaInputComponent,
  TextInputComponent,
  MultipleChoiceInputComponent,
  DatepickerInputComponent,
  CheckboxInputComponent,
  SteppersInputComponent,
  HiddenInputComponent
} from './inputs.component';
import {EntitiesAutocompleteModule} from "../entities-autocomplete/entities-autocomplete.module";
import {DatepickerModule} from "@shopping-angular-components/datepicker";

@NgModule({
    imports: [
        CommonModule,
        TagTextModule,
        EvaButtonModule,
        FormsModule,
        TranslateModule,
        EntitiesAutocompleteModule,
        DatepickerModule
    ],
    exports: [
        FormModuleComponent,
        SteppersInputComponent,
        SelectorInputComponent
    ],
    declarations: [
        CommonInputComponent,
        FormModuleComponent,
        TextInputComponent,
        TextareaInputComponent,
        SelectorInputComponent,
        RadiosInputComponent,
        CheckboxInputComponent,
        InputsWrapperComponent,
        AutocompleteInputComponent,
        InputsWrapperComponent,
        MultipleChoiceInputComponent,
        DatepickerInputComponent,
        SteppersInputComponent,
        HiddenInputComponent
    ],
    providers: [],
})
export class FormModule { }
